import dot from "dot-object";
import moment from "moment";
import { useTranslation } from "react-i18next";

export const baseUrl = "http://localhost:8080/";

export const appendObjectInFormData = (formData, data, name) => {
  formData.append(
    name,
    new Blob([JSON.stringify(data)], {
      type: "application/json",
    })
  );
};

export const basicFormValidationHandler = (
  objectForValidation,
  t = (key) => "Obavezno polje"
) => {
  const errorTranslations = t("taskAdd.requiredField");
  const dotNotationObj = dot(objectForValidation);
  let errorsObject = {};

  Object.entries(dotNotationObj?.separator)?.forEach((entry) => {
    let fieldValue = typeof entry[1] === "string" ? entry[1]?.trim() : entry[1];

    if (typeof entry[1] === "boolean") {
      fieldValue = entry[1].toString();
    }

    if (
      !fieldValue ||
      fieldValue === "" ||
      fieldValue?.length === 0 ||
      fieldValue === 0 ||
      fieldValue === "0"
    ) {
      errorsObject[`${entry[0]}`] = errorTranslations;
    }
  });

  return errorsObject;
};

export const basicFormValidationHandler2 = (objectForValidation) => {
  const errorTranslations = "obavezno polje!";
  const dotNotationObj = dot(objectForValidation);
  let errorsObject = {};
  Object.entries(dotNotationObj?.separator)?.forEach((entry) => {
    let fieldValue = typeof entry[1] === "string" ? entry[1]?.trim() : entry[1];

    if (typeof entry[1] === "boolean") {
      fieldValue = entry[1].toString();
    }
    if (
      fieldValue === undefined ||
      fieldValue === null ||
      (typeof fieldValue === "string" && fieldValue.trim() === "") ||
      (Array.isArray(fieldValue) && fieldValue.length === 0)
    ) {
      errorsObject[entry[0]] = errorTranslations;
    }
  });

  return errorsObject;
};

export const getCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Dodaje nulu ispred ako je jednocifren mesec
  const day = String(now.getDate()).padStart(2, "0"); // Dodaje nulu ispred ako je jednocifren dan
  return `${year}-${month}-${day}`;
};

export const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:00`;
};

export const isValidEmail = (email) => {
  // Regularni izraz za validaciju email adrese
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

  return emailRegex.test(email);
};

export const formatDate = (dateString) => {
  // Pretvorite datum iz stringa u JavaScript Date objekat
  const date = new Date(dateString);

  // Postavite opcije za formatiranje datuma
  const options = {
    year: "numeric",
    month: "long", // "long" znači da će biti pun naziv meseca
    day: "numeric",
  };

  // Koristite toLocaleDateString za formatiranje datuma
  return date.toLocaleDateString(undefined, options);
};

export const formattedPrice = (price) => {
  // Konvertuj string u broj
  const numericPrice = typeof price === "string" ? parseFloat(price) : price;

  // Proveri da li je rezultat validan broj
  if (isNaN(numericPrice)) return ""; // Ako nije broj, vrati prazan string

  // Formatiraj broj sa dve decimale
  const parts = numericPrice.toFixed(2).split(".");
  // Dodaj tačku kao razdvajač hiljada
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  // Vraćanje formatiranog broja
  return parts.join(",");
};

export const formatDateFull = (date) => {
  return (date && moment(date).format("DD.MM.YYYY. HH:mm")) || "";
};

export const formatOnlyDate = (date) => {
  return (date && moment(date).format("DD.MM.YYYY.")) || "";
};

export const formatOnlyDateDB = (date) => {
  return (date && moment(date).format("YYYY-MM-DD")) || "";
};

export const dateValueGetter = (params) => {
  return params.data?.[params.colDef.field]
    ? new Date(params.data[params.colDef.field])
    : null;
};

export const dateFilterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    if (!cellValue) return -1;
    const cellDate = new Date(cellValue);
    if (cellDate.toDateString() === filterLocalDateAtMidnight.toDateString())
      return 0;
    return cellDate < filterLocalDateAtMidnight ? -1 : 1;
  },
};

export const getInitials = (name) => {
  return name
    .split(" ") // Razdvaja ime i prezime
    .map((word) => word[0]) // Uzima prvo slovo svake reči
    .join("") // Spaja ih u string
    .toUpperCase(); // Osigurava da su velika slova
};

export const validateLocalesFields = (locales, fields = ["name", "description","title", "subtitle"]) => {
  const errors = {};

  Object.entries(locales).forEach(([code, locale]) => {
    fields.forEach((field) => {
      if (!locale[field] || locale[field].trim() === "") {
        if (!errors[code]) errors[code] = {};
        errors[code][field] = "Obavezno polje";
      }
    });
  });

  return errors;
};
